import React, { useEffect } from 'react'
import axios from "axios";
import {useSelector,useDispatch} from "react-redux";
import { setMessages } from '../redux/messageSlice';
import { BASE_URL } from '../config';

const useGetMessages = () => {
    const {selectedUser, authUser} = useSelector(store=>store.user);
    const dispatch = useDispatch();
  

useEffect(() => {
    if (!authUser) return; // Prevent fetch if no authenticated user

  const fetchMessages = async () => {
      try {
          let url = `${BASE_URL}/api/v1/message/`;
          
          if (authUser?.isRole === 1 && selectedUser?._id) {
              url += selectedUser._id;
          } else if (authUser?.isRole !== 1) {
              url += 'admins'; // Virtual admin ID
          } else {
              return;
          }

          const res = await axios.get(url, { withCredentials: true });
          if (res.status === 200) {
            dispatch(setMessages(res.data));
        }
        //   dispatch(setMessages(res.data));
      } catch (error) {
          console.log("Error fetching messages:", error);
          if (error.response?.status === 400) {
            // Handle invalid ID case
            dispatch(setMessages([]));
        }
      }
  };
  
  fetchMessages();
}, [selectedUser?._id, authUser, dispatch]);
}

export default useGetMessages